module.exports = __webpack_public_path__ + "static/media/playLogoMobile.bb7b0237.svg";